module.exports = __webpack_public_path__ + "static/image/sustainability/image_conduct.ver2_0_2.jpg?ca588d94";